import React from 'react';

import { Container, Content } from './Button.styles';
import { ButtonProps } from './Button.types';

export function Button({ children, variant = 'contained', size = 'lg', ...props }: ButtonProps) {
  return (
    <Container variant={variant} size={size} {...props}>
      <Content>{children}</Content>
    </Container>
  );
}
